










































































































































































































import { today } from '@/pantallas/Conecta/ConsultaInstalaciones/helpers/getDay';
import { Vue, Component, Watch } from 'vue-property-decorator';
//@ts-ignore
import ResSplitPane from 'vue-resize-split-pane';
import CrearVODModal from '@/pantallas/Camaras/VOD/CrearVODModal.vue';
import { fetchCamaraModulo } from '@/pantallas/Camaras/fetchCamaraModulos';
import { LoadingService } from '@/services/loadingService';
import CamaraEventBus from '@/pantallas/Camaras/CamaraEventBus';
import axios from 'axios';
import MensajeValidacionHRef from '@/pantallas/Informes/partes/MensajeValidacionHRef.vue';

@Component({
  components: { ResSplitPane,  CrearVODModal, MensajeValidacionHRef},
})
export default class CalendarioHistorico extends Vue {
  loadingService: LoadingService = new LoadingService();
  sizeSplitPane: number = 300;
  searchDate: any = null;
  patents: any[] = [];
  selectedPatent: any = '';
  today: Date = new Date();
  $snotify: any;
  playbackList: any[] = [];
  recordsList: any[] = [];
  chartList: any[] = [];
  chartListRecords: any[] = [];
  container: any = null;
  recordContainer: any = null;
  chart: any = null;
  recordsChart: any = null;
  dataTable: any;
  recordsDataTable: any;
  openVideo: boolean = false;
  openRecordVideo: boolean = false;
  openTimeline: boolean = false;
  openRecordsTimeline: boolean = false;
  videoUrl: string = '';
  videoRecordUrl: string = '';
  stepData: string = '2';
  showRecords: boolean = true;
  hls: any = null;
  arrayEvents: string[] = [];
  timelines: any = {
    timeline1: null,
    timeline2: null,
  };
  mousex: any = null;
  mousey: any = null;
  timeoutTooltip: any = null;
  dialogCreateVOD: boolean = false;
  showRedirect: boolean = false;

  created() {
    CamaraEventBus.$on('postVOD', (body: any) => {
      this.dialogCreateVOD = false;
      this.showRedirect = true;
    });
  }

  mounted() {
    var self = this;
    document.addEventListener('mousemove', this.saveCoords);
    this.loadingService = new LoadingService();
    this.chargePatentsCamera();
    this.loadJsVisTimeline();
  }
  beforeDestroy() {
    document.removeEventListener('mousemove', this.saveCoords);
  }

  closeModalRedirect(event: any){
    this.showRedirect = false;
  }

  get getCurrentDay(): string{
    const year = this.today.getFullYear();
    const month = String(this.today.getMonth() + 1).padStart(2, '0'); 
    const day = String(this.today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  saveCoords(event: any) {
    this.mousex = event.clientX;
    this.mousey = event.clientY;
  }

  handleCierreModalCrear() {
    this.dialogCreateVOD = false;
  }

  zoomIn(){
    try{
      this.timelines['timeline'+this.stepData].zoomIn(0.5);
    }catch(e){
      console.log(e)
    }
  }

  zoomOut(){
    try{
      this.timelines['timeline'+this.stepData].zoomOut(0.5);
    }catch(e){
      console.log(e)
    }
  }

  moveLeft(){
    try{
      let currentWindow = this.timelines['timeline'+this.stepData].getWindow();
      const zoomEstimed = (currentWindow.end - currentWindow.start) / 320000;
      console.log("Zoom estimado: "+zoomEstimed);
      var newStartTime = new Date(currentWindow.start.getTime() - (100000*zoomEstimed));
      var newEndTime = new Date(currentWindow.end.getTime() - (100000*zoomEstimed));
      this.timelines['timeline'+this.stepData].setWindow(newStartTime, newEndTime, { animation: true });
    }catch(e){
      console.log(e)
    }
  }

  moveRight(){
    try{
      let currentWindow = this.timelines['timeline'+this.stepData].getWindow();
      const zoomEstimed = (currentWindow.end - currentWindow.start) / 320000;
      console.log("Zoom estimado: "+zoomEstimed);
      var newStartTime = new Date(currentWindow.start.getTime() + (100000*zoomEstimed));
      var newEndTime = new Date(currentWindow.end.getTime() + (100000*zoomEstimed));
      this.timelines['timeline'+this.stepData].setWindow(newStartTime, newEndTime, { animation: true });
    }catch(e){
      console.log(e)
    }
  }

  loadJsVisTimeline() {}

  retryOperation(maxRetries: any, operationFunction: Function) {
    for (let retry = 0; retry < maxRetries; retry++) {
      try {
        operationFunction();
        return;
      } catch (error) {
        console.error(`Intento ${retry + 1} fallido.`);
      }
    }
  }

  handleChangePatent() {
    this.getRecordsDays();
    this.clearFetch();
    this.openVideo = false;
    this.openRecordVideo = false;
    this.recordsList = [];
    this.playbackList = [];
    this.openTimeline = false;
    this.openRecordsTimeline = false;
    this.searchDate = new Date().toISOString().split('T')[0];
    this.setRecordsViewBySystem();
    this.handleChangeCalendary();
  }

  setRecordsViewBySystem() {
    var self = this;
    this.stepData = '2';
    let selectPatent: any = this.patents.findIndex(
      (patent: any) => patent.cod == this.selectedPatent
    );
    if (selectPatent != -1) {
      if (
        this.patents[selectPatent].hasOwnProperty('sistema') &&
        this.patents[selectPatent].sistema == 'HOWEN'
      ) {
        this.showRecords = false;
        setTimeout(() => {
          self.stepData = '1';
        }, 1000);
      } else {
        this.showRecords = true;
        if (this.stepData == '1') {
          this.stepData = '2';
        }
      }
    }
  }

  getRecordsDays() {
    this.loadingService.showLoading('Por favor espere...', 'getRecordsDays');
    var body: any = {
      id_cliente: this.getClientID().toString(),
      id_usuario: this.getUserID().toString(),
      id_camara: this.selectedPatent,
    };

    fetchCamaraModulo(body, 'getRecordsDaysCamera')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.arrayEvents = response.data.data;
        } else {
          this.arrayEvents = [];
          this.$snotify.error('Error al traer los registros');
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.arrayEvents = [];
      })
      .finally(() => {
        this.loadingService.hideLoading('getRecordsDays');
      });
  }

  handleRecordsTab() {
    this.stepData = '2';
  }

  clearTimeline(type: string) {
    var self = this;
    const container = document.getElementById('timeline' + type);
    container.innerHTML = '';
    try {
      this.timelines['timeline' + type].off('click', this.selectItem);
    } catch (e) {
      console.log(e);
    }
    try {
      this.timelines['timeline' + type].off('itemover', function(
        properties: any
      ) {
        var itemId = properties.item;
        var item = self.chartListRecords[itemId];
        clearTimeout(self.timeoutTooltip);
        self.timeoutTooltip = setTimeout(() => {
          self.showTooltip(item, type);
        }, 500);
      });
    } catch (e) {
      console.log(e);
    }
    try {
      this.timelines['timeline' + type].off('itemout', function() {
        setTimeout(() => {
          var tooltip = document.getElementById('custom-tooltip');
          tooltip.style.display = 'none';
        }, 500);
      });
    } catch (e) {
      console.log(e);
    }
    try {
      this.timelines['timeline' + type].destroy();
    } catch (e) {
      console.log(e);
    }
  }

  clearFetch() {
    try {
      this.hls.destroy();
    } catch (error) {
      console.log('');
    }
  }

  handleTab() {
    this.stepData = '1';
  }

  async loadM3u8Video() {
    var self = this;
    var video: any = document.getElementById('videoM3u8');
    if (video.canPlayType('application/vnd.apple.mpegurl')) {
      console.log('--- 1');
      this.$snotify.success('Procesando video...', { timeout: 1000 });
      video.src = this.videoRecordUrl;
      //@ts-ignore
    } else if (Hls.isSupported()) {
      console.log('--- 2');
      this.clearFetch();
      this.loadingService.showLoading();
      fetch(this.videoRecordUrl)
        .then((response: any) => response.text())
        .then((content: string) => {
          const lines: string[] = content.split('\n'); //.map((line: any) => line.trim());
          console.log(lines[0], lines[1], lines[2], lines[3]);
          if (lines.length >= 4) {
            if (
              lines[0].trim() == '#EXTM3U' &&
              lines[3].trim() == '#EXT-X-ENDLIST'
            ) {
              this.$snotify.error('Video sin contenido');
            } else {
              this.$snotify.success('Procesando video...', { timeout: 1000 });
              this.initializeHls(video);
            }
          } else {
            this.$snotify.error('Hubo un error al obtener el video');
          }
        })
        .finally(() => {
          self.loadingService.hideLoading();
        });
    }
  }

  initializeHls(video: any) {
    var self = this;
    //@ts-ignore
    const configHls = 
    { maxMaxBufferLength: 2400, 
      debug: true, 
      nudgeMaxRetry: 24,
      levelLoadingMaxRetry: 2400,
      fragLoadingMaxRetry: 2400
    }
    //@ts-ignore
    this.hls = new Hls(configHls);
    this.hls.loadSource(this.videoRecordUrl);
    this.hls.attachMedia(video);

    //@ts-ignore
    this.hls.on(Hls.Events.MANIFEST_PARSED, function() {
      console.log('ENTRADA!');
      if (self.hls.levels.length === 0) {
        // El archivo .m3u8 es vacío, quitar el "loading"
        console.log('El archivo .m3u8 es vacío.');
        // Detener la carga del elemento de video
        video.pause();
        video.style.display = 'none'; // Opcionalmente, ocultar el elemento de video
      } else {
        // El archivo .m3u8 contiene segmentos de video, continuar la reproducción.
        console.log('CARGÓ!');
        video.play();
        //self.handleEventsM3u8(video);
      }
      //video.play();
      //self.handleEventsM3u8(); // Agrega manejadores de eventos después de que el video se inicie
    });
  }

  handleEventsM3u8(video: any) {
    //@ts-ignore
    this.hls.off(Hls.Events.ERROR);
    //@ts-ignore
    this.hls.on(Hls.Events.ERROR, function(event, data) {
      //@ts-ignore
      if (data.type === Hls.ErrorTypes.NETWORK_ERROR) {
        console.error('Error de red al cargar el archivo .m3u8');
        //@ts-ignore
      } else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) {
        //@ts-ignore
        if (data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR) {
          console.error('Error al cargar el archivo .m3u8 (manifest)');
          //@ts-ignore
        } else if (data.details === Hls.ErrorDetails.MANIFEST_PARSE_ERROR) {
          console.error('Error al analizar el archivo .m3u8 (manifest)');
        } else {
          console.error('Error de contenido de video');
        }
      }
      //@ts-ignore
      //this.hls.stopLoad();
      // video.pause();
      // video.load();
    });
  }

  async downloadVideo(videoUrl: string, urlConverter: string) {
    this.loadingService.showLoading();
    var video: string = await this.getVideo(videoUrl, urlConverter);
    if (video != '') {
      this.videoUrl = video;
      this.openVideo = true;
    }
    this.loadingService.hideLoading();
  }

  async getVideo(videoUrl: string, urlConverter: string): Promise<string> {
    try {
      var response = await axios.post(urlConverter, { url: videoUrl });
      this.loadingService.hideLoading();
      if (response.data.CODIGO_RESPUESTA == '1') {
        return response.data.data.new_url;
      } else {
        this.$snotify.error('Hubo un error al intentar abrir el video');
        return '';
      }
    } catch (error) {
      console.log(error);
      this.$snotify.error('Hubo un error al intentar abrir el video');
      this.loadingService.hideLoading();
      return '';
    }
  }

  handleChangeCalendary() {
    if (this.selectedPatent == '') {
      this.$snotify.warning(
        'Debe ingresar una patente para realizar la búsqueda'
      );
      return;
    }
    this.getPlayback();
    if (this.showRecords) {
      this.getRecords();
    }
  }

  async chargePatentsCamera() {
    this.loadingService.showLoading(
      'Por favor espere...',
      'chargePatentsCamera'
    );
    const body: {} = {
      id_cliente: this.getClientID(),
      id_usuario: this.getUserID().toString(),
    };
    fetchCamaraModulo(body, 'getPatentCameras')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.patents = response.data.data || [];
        } else {
          this.$snotify.error('Error al obtener las patentes');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loadingService.hideLoading('chargePatentsCamera');
      });
  }

  async getPlayback() {
    this.loadingService.showLoading('Por favor espere...', 'getPlayback');

    let self = this;
    const patent: any = this.patents.find(
      (item: any) => item.cod == this.selectedPatent
    ).patente;

    var body: any = {
      id_cliente: this.getClientID().toString(),
      id_usuario: this.getUserID().toString(),
      id_camara: this.selectedPatent,
      fecha_inicio: this.searchDate.toString() + ' 00:00:00',
      fecha_fin: this.searchDate.toString() + ' 23:59:59',
      patente: patent,
      chl: '',
      all: true,
    };

    fetchCamaraModulo(body, 'busqueda_playback_camara')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.playbackList = response.data.data;
        } else {
          this.$snotify.error('Error al traer los registros');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        self.proccessPlayBack();
        this.loadingService.hideLoading('getPlayback');
      });
  }

  async getRecords() {
    this.loadingService.showLoading('Por favor espere...', 'getRecords');

    let self = this;
    const patent: any = this.patents.find(
      (item: any) => item.cod == this.selectedPatent
    ).patente;

    var body: any = {
      id_cliente: this.getClientID().toString(),
      id_usuario: this.getUserID().toString(),
      id_camara: this.selectedPatent,
      fecha_inicio: this.searchDate.toString() + ' 00:00:00',
      fecha_fin: this.searchDate.toString() + ' 23:59:59',
      patente: patent,
      chl: '',
      all: true,
    };

    fetchCamaraModulo(body, 'busqueda_registro_camara')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.recordsList = response.data.data;
        } else {
          this.$snotify.error('Error al traer los registros');
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        self.proccessRecords();
        this.loadingService.hideLoading('getRecords');
      });
  }

  proccessRecords() {
    if (this.recordsList.length == 0) {
      this.openRecordsTimeline = false;
      return;
    } else {
      this.openRecordsTimeline = true;
    }
    this.clearTimeline('2');

    this.chartListRecords = this.recordsList.reduce(
      (acumulador: any, playback: any, index: any) => {
        if (new Date(playback.fecha_ini) < new Date(playback.fecha_fin)) {
          //acumulador.push(['Canal '+playback.channel, new Date(playback.fecha_ini), new Date(playback.fecha_fin)])
          acumulador.push({
            id: index,
            content: '',
            start: new Date(playback.fecha_ini),
            end: new Date(playback.fecha_fin),
            group: playback.channel,
            style: 'background-color: #339233;',
          });
        }
        return acumulador;
      },
      []
    );

    this.generateRecordsVisTimeline('2', this.chartListRecords);
  }

  handleCreateVOD(){
    this.dialogCreateVOD = true;
    console.log("SelectedPatent ->", this.selectedPatent);
  }

  selectItem(properties: any) {
    let itemId = properties.item;
    if (itemId == null || itemId == undefined) {
      return;
    }
    this.clearFetch();
    if (this.stepData == '1') {
      this.handleTabInfo(this.chartList[itemId]);
      this.openRecordVideo = false;
      this.openVideo = true;
      console.log(this.playbackList[itemId]);
      this.downloadVideo(
        this.playbackList[itemId].url,
        this.playbackList[itemId].url_converter
      );
    } else {
      this.handleTabInfo(this.chartListRecords[itemId]);
      this.openVideo = false;
      this.openRecordVideo = true;
      console.log(this.recordsList[itemId]);
      let startDate = this.recordsList[itemId].fecha_ini
        .toString()
        .replaceAll('-', '')
        .replaceAll(' ', '')
        .replaceAll(':', '');
      let endDate = this.recordsList[itemId].fecha_fin
        .toString()
        .replaceAll('-', '')
        .replaceAll(' ', '')
        .replaceAll(':', '');
      let chl = parseInt(this.recordsList[itemId].channel) - 1;
      let url = `https://live.gpschile.com/play/127.0.0.1/${this.selectedPatent}/${chl}/${startDate}_${endDate}.m3u8`;
      this.videoRecordUrl = url;
      console.log(url);
      this.loadM3u8Video();
    }
  }

  handleTabInfo(item: any) {
    var tabInfoDiv = document.getElementById('tabInfoDiv');
    const stardDate =
      this.padLeft(item.start.getHours()) +
      ':' +
      this.padLeft(item.start.getMinutes()) +
      ':' +
      this.padLeft(item.start.getSeconds()); //+ (item.start.getHours() >= 12 ? ' pm': ' am');
    const endDate =
      this.padLeft(item.end.getHours()) +
      ':' +
      this.padLeft(item.end.getMinutes()) +
      ':' +
      this.padLeft(item.end.getSeconds()); //+ (item.end.getHours() >= 12 ? ' pm': ' am');
    tabInfoDiv.innerHTML =
      'Canal: ' + item.group + ' | ' + stardDate + ' a ' + endDate;
  }

  proccessPlayBack() {
    if (this.playbackList.length == 0) {
      this.openTimeline = false;
      return;
    } else {
      this.openTimeline = true;
    }
    this.clearTimeline('1');
    this.chartList = this.playbackList.reduce(
      (acumulador: any, playback: any, index: any) => {
        if (
          new Date(playback.fecha_ini_file) < new Date(playback.fecha_fin_file)
        ) {
          //acumulador.push(['Canal '+playback.channel, new Date(playback.fecha_ini_file), new Date(playback.fecha_fin_file)])
          acumulador.push({
            id: index,
            content: '',
            start: new Date(playback.fecha_ini),
            end: new Date(playback.fecha_fin),
            group: playback.channel,
            style: 'background-color: #339233;',
          });
        }
        return acumulador;
      },
      []
    );

    this.generateRecordsVisTimeline('1', this.chartList);
  }

  generateRecordsVisTimeline(type: any, items: any[]) {
    var self = this;
    const container = document.getElementById('timeline' + type);
    container.innerHTML = '';
    // @ts-ignore
    let groups = new vis.DataSet([
      { id: 1, content: 'Canal 1' },
      { id: 2, content: 'Canal 2' },
      { id: 3, content: 'Canal 3' },
      { id: 4, content: 'Canal 4' },
    ]);
    const startDate: string = this.searchDate + ' 00:00:00';
    const endDate: string = this.searchDate + ' 23:59:59';

    var options = {
      start: startDate,
      end: endDate,
      showCurrentTime: false,
      zoomMax: 86400000,
      zoomMin: 10000,
      min: startDate,
      max: endDate,
      stack: false,
    };

    try {
      this.timelines['timeline' + type].off('click', this.selectItem);
    } catch (e) {
      console.log(e);
    }
    // @ts-ignore
    this.timelines['timeline' + type] = new vis.Timeline(
      container,
      items,
      groups,
      options
    );
    this.timelines['timeline' + type].on('click', this.selectItem);
    this.timelines['timeline' + type].on('itemover', function(properties: any) {
      var itemId = properties.item;
      var item = {};
      if(type == '1'){
        item = self.chartList[itemId];
      }else{
        item = self.chartListRecords[itemId];
      }
      clearTimeout(self.timeoutTooltip);
      self.timeoutTooltip = setTimeout(() => {
        self.showTooltip(item, type);
      }, 500);
    });

    this.timelines['timeline' + type].on('itemout', function() {
      setTimeout(() => {
        var tooltip = document.getElementById('custom-tooltip');
        tooltip.style.display = 'none';
      }, 500);
    });

    this.addCssTimeline();
    //this.timeline1 = new vis.Timeline(container, items, groups, options);
  }

  addCssTimeline(){
    var elements = document.querySelectorAll('.vis-item');
    // Iterar sobre la NodeList y editar la clase existente
    elements.forEach(function(element: any) {
      // Por ejemplo, cambiar el color y el tamaño de la fuente
      element.style.cursor = 'pointer';
    });
  }

  padLeft(valor: any) {
    return valor < 10 ? '0' + valor : valor.toString();
  }

  showTooltip(item: any, type: any) {
    var tooltip = document.getElementById('custom-tooltip');
    const stardDate =
      this.padLeft(item.start.getHours()) +
      ':' +
      this.padLeft(item.start.getMinutes()) +
      ':' +
      this.padLeft(item.start.getSeconds()); //+ (item.start.getHours() >= 12 ? ' pm': ' am');
    const endDate =
      this.padLeft(item.end.getHours()) +
      ':' +
      this.padLeft(item.end.getMinutes()) +
      ':' +
      this.padLeft(item.end.getSeconds()); //+ (item.end.getHours() >= 12 ? ' pm': ' am');
    tooltip.innerHTML =
      'Canal: ' + item.group + ' | ' + stardDate + ' a ' + endDate;
    tooltip.style.left = this.mousex + 'px';
    tooltip.style.top = this.mousey - tooltip.offsetHeight - 25 + 'px'; // Ajustar la posición
    tooltip.style.display = 'block';
  }

  getStateString(state: string): string {
    var stateString: string = '';
    if (state == 'Linea') {
      stateString = 'En Línea';
    } else if (state == 'Desconecta') {
      stateString = 'Desconectado';
    } else if (state == 'Sin Info') {
      stateString = 'Sin Información';
    }
    return stateString;
  }

  getHtmlFromState(state: string): string {
    const style =
      'width: 24px; height: 24px;margin-top: 2%; border-radius: 50%; ';
    var html = '';
    var css = '';
    if (state == 'Linea') {
      css = style + ' background: rgb(42, 255, 78)';
    } else if (state == 'Desconecta') {
      css = style + ' background: rgb(255, 58, 58)';
    } else if (state == 'Sin Info') {
      css = style + ' background: rgb(33, 33, 255)';
    }
    return css;
  }

  textoComprimido(item: any) {
    let retorno: string = '';
    if (item.length > 14) {
      retorno = item.substr(0, 13) + '...';
    } else {
      retorno = item;
    }
    return retorno;
  }

  getClientID(): number {
    return parseInt(localStorage.getItem('clienteDefecto'));
    // return 5216;
  }
  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
}
